const defaultState = {
    //Module state
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        default: return state;
    }
};